import { Component, OnInit } from '@angular/core';
import {CommonService} from "../../../_services/common.service";

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  currentLanguage = this.commonService.currentLanguage;
  header: string = 'Reach Out To Us';
  description: string = 'Reach out about a general enquiry company formations or to connect with one of our experts';
  joinChat: boolean = false;
  imagePath = "../../../../assets/images/undraw_mobile_search_jxq5 1.png";
  hasBtn: boolean = false;

  showForm = false
  constructor(private commonService: CommonService) {

  }

  ngOnInit(): void {
    // this.commonService.loadScript('https://webforms.pipedrive.com/f/loader')

  }


}
